import { HttpClientModule, HttpClient } from '@angular/common/http';
import { TranslateModule, TranslateLoader } from '@ngx-translate/core';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';
import { NgxFlickingModule } from '@egjs/ngx-flicking';

import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { HomeComponent } from './home/home.component';
import { LoginComponent } from './login/login.component';
import { RegisterComponent } from './register/register.component';
import { FooterComponent } from './footer/footer.component';
import { HeaderComponent } from './header/header.component';
import { TermsConditionsComponent } from './terms-conditions/terms-conditions.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { PasswordResetComponent } from './password-reset/password-reset.component';
import { PasswordNewComponent } from './password-new/password-new.component';

export function createTranslateLoader(http: HttpClient) {

  let currentDate = new Date();
  let timestamp = currentDate.getTime();

  return new TranslateHttpLoader(http, './assets/i18n/', '.json?v=' + timestamp);
}

@NgModule({
  declarations: [
    AppComponent,
    HomeComponent,
    LoginComponent,
    RegisterComponent,
    FooterComponent,
    HeaderComponent,
    TermsConditionsComponent,
    PasswordResetComponent,
    PasswordNewComponent
  ],
  imports: [
    BrowserModule,
    AppRoutingModule,
    NgxFlickingModule,
    FormsModule,
    HttpClientModule,
    ReactiveFormsModule,
    TranslateModule.forRoot({
      loader: {
        provide: TranslateLoader,
        useFactory: (createTranslateLoader),
        deps: [HttpClient]
      }
    }),

  ],
  providers: [],
  bootstrap: [AppComponent]
})
export class AppModule {
constructor() {

  }
   }
